export default __webpack_public_path__ + "media/zurb/img/ecommerce/jab_6-1d93d513e473a7186df755315fd64d52.png";